import React from "react";
import Components from "mpm-components";
import { Form, Divider } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";

export default ({ cessionExport, entities }) => {
    return (
      <Components.Regions.RegionWithHeader
        title="menu.demande.export"
        headerColor="blue"
        headerSize="small"
      >
        <Form>
          <Form.Group widths="equal">
            <Form.Checkbox toggle 
            checked={cessionExport.certificatManuelle}  
            disabled
            label="Choisir Demande SAP"
            />

            {
              cessionExport.certificatManuelle ? 
              <>
                  <DateInput
                    label={
                      <label>
                        Date Cértificat Exportation SAP<font color="red">*</font>
                      </label>
                    }
                    type="text"
                    name="dateVisa"
                    icon="calendar"
                    iconPosition="right"
                    value={cessionExport.dateVisa}
                    dateFormat="DD/MM/YYYY"
                    disabled
                  />
                <Form.Input
                  required
                  label="Numéro Cértificat Exportation SAP"
                  value={cessionExport.numeroCertificat}
                  disabled
                />
              </>
              :
              <>
                <Form.Field />
                <Form.Field />
              </>
            }


          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              width="15"
              label="Référence Demande Exportation"
              disabled
              value={cessionExport.numeroCessionComplet}
            />
            <Form.Input
              label="Date Système "
              disabled
              value={cessionExport.dateSysteme}
            />
            <Form.Input
              label="Date Demande Exportation "
              disabled
              value={cessionExport.dateCession}
            />
          </Form.Group>
          <Divider />
          <Form.Select
            width="5"
            label="DPM De Validation"
            options={entities.data}
            disabled
            value={cessionExport.id_RefDpmValid}
          />
        </Form>
      </Components.Regions.RegionWithHeader>
    );
  };